import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const ActivationSetLeaderCellButtonWrapper = styled(Flex)`
    padding: 4px;
    width: 26px;
    height: 26px;
    margin-right: 12px;
    border-radius: 3px;
    cursor: pointer;
    border: 1px solid ${colorsPalettes.carbon[100]};
    ${SWReactIcons} {
        display: flex;
    }
`;

export const EnrichTopContainer = styled(Flex)`
    justify-content: space-between;
    align-items: center;
    padding: 0 20px 0 24px;
    height: 50px;
`;

export const EnrichIndexContainer = styled.div`
    margin: 0 8px 0 36px;
`;

export const EnrichDataContainer = styled(Flex)`
    align-items: center;
    flex-grow: 1;
    justify-content: flex-start;
`;

export const EnrichPageContainer = styled.div`
    height: auto;
    width: 312px;
    border: none;
`;
const Right = styled(Flex)`
    align-items: center;
    margin-left: 10px;
`;
const HeaderStyle = styled(Flex)`
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
`;

const StyledHeaderTitle = styled.div`
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
    padding-bottom: 8px;
`;

const StyledBoxSubtitle = styled.div`
    ${setFontVariant("caption", colorsPalettes.carbon[400])};
`;
